import {useMatch} from 'external/react'
import {
  Box,
  Fade
} from 'external/material'
import Assignment from './Assignment'

import {getPageRoute,getGroupRoute} from 'utils/routing'
import useStudentContext from 'hooks/student'

export default function Assignments({id}) {
  const {params} = useMatch(getPageRoute(getGroupRoute(':sectionId/*')))
  const {assignments = {}} = useStudentContext()
  const counts = Object.entries(assignments[id] || {}) || []
  const {sectionId} = params || {}

  return (
  <Fade in={counts.length > 0}>
    <Box className="assignments">
        {counts.map(([type, count], i) => {
          const active = type == sectionId
          const iconProps = active
            ? {height: 29, fill: '#fff', backgroundColor: '#1994fe'}
            : {height: 29, fill: '#45c7ff'}
          return (<Assignment key={i} {...{id, count, type, active, iconProps}} />)
        }) }
    </Box>
  </Fade>
  )
}
